export default "__VITE_ASSET__CjrFqpnQ__"